export const VIDEO_CREATOR_LAYOUT = {
  modelAreaHeight: 290,
  modelAreaHeightExpanded: 426,
  modelAreaHeightMobile: 139,

  propertiesHeightNoAudio: 66,
  promptShortNoError: 148,
  /** Extra height when error message is shown */
  promptErrorDelta: 40,
  /** Extra height when prompt is long */
  promptLongDelta: 100,
  /** Mobile doesn't show file upload, so needs less space */
  promptMobileDelta: 40,
  /** Extra properties height when audio model is selected */
  propertiesAudioDelta: 74,
} as const;
